import { UseQueryOptions, useQuery } from "react-query";
import { http } from "./http";
import { ServiceEarning, SongEarning } from "@arelia-types/earnings";

export function useRecordingRoyaltiesSummaryQuery(ops?: UseQueryOptions<any>) {
  return useQuery({
    queryKey: ["/api/earnings/recording-royalties"],
    queryFn: () => http("/api/earnings/recording-royalties"),
    ...ops
  });
}

export function usePublishingRoyaltiesQuery(ops?: UseQueryOptions<any>) {
  return useQuery({
    queryKey: ["/api/earnings/publishing-royalties"],
    queryFn: () => http("/api/earnings/publishing-royalties"),
    ...ops
  });
}

export function useSongEarningsQuery() {
  return useQuery<SongEarning[]>({
    queryKey: ["/api/earnings/song-earnings"],
    queryFn: () => http("/api/earnings/song-earnings")
  });
}

export function useServiceEarningsQuery() {
  return useQuery<ServiceEarning[]>({
    queryKey: ["/api/earnings/service-earnings"],
    queryFn: () => http("/api/earnings/service-earnings")
  });
}
